import React, { useEffect, useState } from "react";
import * as service from "../../store/service";

const EFTAuthDetails = (props: { dialogId: string; closeDialog: any }) => {
    const [loading, setLoading] = useState(false);
    const [eftContent, setEftContent] = useState({
        type: "",
        value: "",
    });

    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");

        setLoading(true);
        service
            .getEFTInfo()
            .then((data) => {
                if (data.isSuccess && data.eftContent && data.eftContent.length > 0 && data.eftContent[0].type && data.eftContent[0].value) {
                    setEftContent(data.eftContent[0]);
                } else {
                    setEftContent({ type: "Content Not Found", value: "Something went wrong. Please try again later." });
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                setEftContent({ type: "Content Not Found", value: "Something went wrong. Please try again later." });
            });
    }, []);

    return (
        <React.Fragment>
            <div className="dialog-header">
                <h1>{eftContent.type ? eftContent.type : "Content Not Found"}</h1>
            </div>
            <div className={loading ? " loading dialog-body" : "dialog-body"}>
                <p>{eftContent.value ? eftContent.value : ""}</p>
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={() => props.closeDialog()}>
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default EFTAuthDetails;
